import { fractionDigitsForCurrency } from './currencyFractionDigits';

/** Moneda de la org en runtime (una moneda por venta hoy). */
export type MoneyScale = {
  currency: string;
  fractionDigits: number;
};

export const DEFAULT_MONEY_SCALE: MoneyScale = {
  currency: 'ARS',
  fractionDigits: 2,
};

export function moneyScaleForCurrency(currencyCode: string | null | undefined): MoneyScale {
  const currency = (currencyCode ?? DEFAULT_MONEY_SCALE.currency).trim().toUpperCase() || 'ARS';
  return {
    currency,
    fractionDigits: fractionDigitsForCurrency(currency),
  };
}
